import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

export const useSidebarController = () => {
  const location = useLocation()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [expandedMenuItem, setExpandedMenuItem] = useState([])
  const handleDrawerOptions = useCallback((label) => {
    const isAlreadyExpanded = expandedMenuItem.includes(label)
    if (isAlreadyExpanded) {
      // Shrink that menu list
      setExpandedMenuItem((prev) => prev.filter((item) => item !== label))
    } else {
      // Expand that menu list
      setExpandedMenuItem(prev => prev.concat(label))
    }
  }, [expandedMenuItem])

  return {
    t,
    location,
    navigate,
    expandedMenuItem,
    handleDrawerOptions
  }
}
